<template>
	<v-dialog v-model="dialog" persistent max-width="900" scrollable>
		<template v-if="!loading">
			<v-card>
				<v-card-title class="justify-space-between pb-0">
					<div class="font-size-14 font-size-xs-11 cl-secondary">Detail Pembelian {{ detailTransaction.transaction_code }}</div>
					<v-btn small text class="px-0 mr-n4" @click="modalHide">
						<v-icon color="red">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<div class="py-3">
						<v-row>
							<v-col cols="12" sm="6" md="3" class="font-size-10">
								<div class="font-weight-bold">Tanggal</div>
								<div class="">{{ detailTransaction.transaction_datetime | tanggaljam }}</div>
							</v-col>
							<v-col cols="12" sm="6" md="4" class="pt-0 pt-sm-3 font-size-10">
								<div class="font-weight-bold">Nama Mitra</div>
								<div class="" v-if="detailTransaction.transaction_member_network_code">{{ detailTransaction.transaction_member_name + ' ( ' + detailTransaction.transaction_member_network_code + ' )' }}</div>
								<div class="" v-else>{{ detailTransaction.transaction_member_name }}</div>
							</v-col>
							<v-col cols="12" sm="6" md="2" class="pt-0 pt-md-3 font-size-10 text-md-center">
								<div class="font-weight-bold">Status</div>
								<div class="text-capitalize">
									<v-chip
									small
									:color="getTransactionStatus(detailTransaction.transaction_status).color"
									class="font-weight-bold white--text text-uppercase"
									>{{ getTransactionStatus(detailTransaction.transaction_status).label }}</v-chip>
								</div>
							</v-col>
							<v-col cols="12" sm="6" md="3" class="pt-0 pt-md-3 font-size-10 text-md-right">
								<div class="font-weight-bold">Total Harga</div>
								<div class="font-weight-600 font-size-12 cl-primary">{{ detailTransaction.transaction_total_price | toRupiah }}</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pt-2">
								<v-card class="pa-3 elevation-0 rounded-lg bg-primary-light">
									<div class="font-size-11 font-weight-bold grey--text text--darken-2">Detail Produk</div>
								</v-card>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pt-0">
								<v-card outlined class="rounded-lg">
									<v-simple-table class="white-row table-vo-detail table-history-bonus">
										<template v-slot:default>
											<thead class="">
												<tr>
													<th class="text-left font-size-11" width="16%">Kode</th>
													<th class="text-left" width="16%">Tipe</th>
													<th class="text-left" width="22%">Nama</th>
													<th class="text-center" width="10%">Qty</th>
													<th class="text-right" width="16%">Harga(Rp)</th>
													<th class="text-right" width="16%">Total(Rp)</th>
												</tr>
											</thead>
											<tbody class="grey--text text--darken-3">
												<tr v-for="(product, idp) in detailTransaction.transaction_detail" :key="idp">
													<td class="text-left">{{ product.transaction_detail_product_code }}</td>
													<td class="text-left text-capitalize">{{ product.transaction_detail_product_serial_type }}</td>
													<td class="text-left">{{ product.transaction_detail_product_name }}</td>
													<td class="text-center">{{ product.transaction_detail_qty | toNumber }}</td>
													<td class="text-right">{{ product.transaction_detail_unit_price | toNumber }}</td>
													<td class="text-right">{{ (product.transaction_detail_qty) * (product.transaction_detail_unit_price) | toNumber }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</template>
		<template v-else>
			<LoadData :loading="loading"></LoadData>
		</template>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			loading: true,
			transactionStatus: [
			{
				status: 'sukses',
				color: 'success',
				label: 'Sukses',
				icon: 'mdi-check-decagram-outline'
			},
			{
				status: 'menunggu',
				color: 'warning',
				label: 'Menunggu',
				icon: 'mdi-timer-sand'
			},
			{
				status: 'ditolak',
				color: 'error',
				label: 'Ditolak',
				icon: 'mdi-close-circle-outline'
			}
			]
		}
	},
	computed: {
		...mapState('masterStockist', ['detailTransaction']),
	},
	methods: {
		...mapActions('masterStockist', ['getDetailTransaction']),

		getTransactionStatus(status) {
			const transaction = this.transactionStatus.find(x => x.status === status)
			if (transaction) {
				return transaction
			}
			else {
				const nontransaction = {
					status: '',
					color: 'secondary',
					label: '',
					icon: ''
				}
				return nontransaction
			}
		},
		modalShow(id) {
			this.dialog = true
			this.getDetailTransaction({id: id}).then(() => {
				this.loading = false
			})
		},
		modalHide() {
			this.dialog = false
			setTimeout(() => {
				this.loading = true
			}, 300)
		},
		sortFirst(data) {
			if (data) {
				let firstData = data.filter(item => item.transaction_detail_product_name === 'STARTER KIT')
				let newData = data.filter(item => item.transaction_detail_product_name !== 'STARTER KIT')
				if (firstData[0] !== undefined) newData.unshift(firstData[0])
					return newData
			}
		}
	}
};
</script>